// @ts-strict-ignore
import { NumberUtils } from '@shared/util/number-utils';

export class DrillingHoleSize {
  public static readonly SIZE_SEPARATOR: string = ' x ';

  /**
   * size of the drilling hole on the mounting rail
   */
  public sizeOnLine: number;

  /**
   * width of the drilling hole
   */
  public width: number;

  /**
   * label to display
   */
  public sizeLabel: string;

  public constructor(size: number = NaN, width: number = NaN, label: string = null) {
    this.sizeOnLine = size;
    this.width = width;
    this.sizeLabel = label;
  }

  public equals(size: DrillingHoleSize): boolean {
    if (!size) {
      return false;
    }
    return this.sizeOnLine === size.sizeOnLine && this.sizeLabel === size.sizeLabel
      && ((NumberUtils.isNotNumber(this.width) && NumberUtils.isNotNumber(size.width)) || this.width === size.width);
  }

  public clone(): DrillingHoleSize {
    const cloneObject: DrillingHoleSize = new DrillingHoleSize();
    cloneObject.sizeOnLine = this.sizeOnLine;
    cloneObject.width = this.width;
    cloneObject.sizeLabel = this.sizeLabel;
    return cloneObject;
  }
}

export class DrillingHoleRange {
  public min: number;
  public max: number;

  public constructor(min: number, max: number) {
    this.min = min;
    this.max = max;
  }
}
